import type { DeliveryReportRow } from "../../api/reports";
import "./report-table.css";

interface ReportTableProps {
    data: DeliveryReportRow[];
    groupBy: "team" | "flyer" | "timeline";
}

export const ReportTable = ({ data, groupBy }: ReportTableProps): JSX.Element => {
    // Only the flyer grouping is per campaign; team and timeline rows span campaigns.
    const showCampaign = groupBy === "flyer";

    if (data.length === 0) {
        return (
            <div className="report-table__empty">
                <p>Inga data hittades för de valda filtren.</p>
            </div>
        );
    }

    return (
        <div className="report-table__container">
            <table className="report-table">
                <thead>
                    <tr>
                        {showCampaign && <th>Kampanj</th>}
                        {groupBy === "team" && <th>Team</th>}
                        {groupBy === "flyer" && <th>Flygblad</th>}
                        {groupBy === "timeline" && <th>Datum</th>}
                        <th>Antal utdelningar</th>
                        <th>Totalt antal flygblad</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            {showCampaign && <td>{row.campaignName || "-"}</td>}
                            {groupBy === "team" && <td>{row.flyerName}</td>}
                            {groupBy === "flyer" && <td>{row.flyerName}</td>}
                            {groupBy === "timeline" && (
                                <td>{row.flyerName ? new Date(row.flyerName).toLocaleDateString("sv-SE") : "-"}</td>
                            )}
                            <td>{row.deliveries.toLocaleString()}</td>
                            <td>{row.quantitySum?.toLocaleString() || "-"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};